module.exports = __webpack_public_path__ + "static/media/credibly.de9133be.pdf";